module.exports = __webpack_public_path__ + "static/media/26b.d074878c.jpg";